export default __webpack_public_path__ + "static/media/store-umbrella1.43e7d473.png";